export const cepNewNumber = "2016840";
export const cepRecycledNumber = "2016871";
